"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingRecordTypes = void 0;
/**
 * This is deprecated
 * @deprecated
 */
var MarketingRecordTypes;
(function (MarketingRecordTypes) {
    MarketingRecordTypes["LEADS"] = "LEADS";
    MarketingRecordTypes["REFERRAL"] = "REFERRAL";
    MarketingRecordTypes["ITS_BEEN_A_WHILE_6_MONTHS"] = "ITS_BEEN_A_WHILE_6_MONTHS";
})(MarketingRecordTypes = exports.MarketingRecordTypes || (exports.MarketingRecordTypes = {}));
